import React from 'react'
import { FiImage } from 'react-icons/fi'

export default function BranchImageThumb({ src, alt = '', onClick }) {
  if (!src) {
    return (
      <span className='branch-thumb-placeholder'>
        <FiImage />
      </span>
    )
  }

  return (
    <img
      className='branch-thumb'
      src={src}
      alt={alt}
      onClick={onClick}
    />
  )
}
